export default __webpack_public_path__ + "static/media/USONV_Medical_Release_Form.65b689e9.pdf";